import { useEffect } from 'react';
import { useRouter } from 'next/router';

import useSelectedSocialProfileById from '@/utils/hooks/socialprofiles/useSelectedSocialProfileById';
// Hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import type { SocialProfileType } from '@/types/socialProfileType';
// Types
import type { NotificationContentProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

// Routes
import { CONTENT_ALBUM_POSTS } from '@/routes/privateRoutes';

const NewContentAutomaticAlbum = ({ notification }: NotificationContentProps) => {
    const router = useRouter();
    const { selectedSocialProfile } = useSelectedSocialProfileById(
        notification?.data?.social_profile_id as SocialProfileType['id']
    );
    const { setActiveSocialProfile } = useActiveSocialProfile();
    const url = CONTENT_ALBUM_POSTS.replace('[albumId]', notification?.data?.album_id.toString());

    // Prefetch Overview
    useEffect(() => {
        router.prefetch(url);
    }, []);

    return (
        <Notification
            dataNotification={notification}
            onClick={() => {
                if (selectedSocialProfile) {
                    setActiveSocialProfile(selectedSocialProfile);
                    router.push(url);
                }
            }}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Avatar socialProfile={selectedSocialProfile} />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.new_content_automatic_album.title" />
                <Notification.Description
                    i18nKey="commons:notifications.new_content_automatic_album.description"
                    values={{
                        album_name: notification?.data?.album_name
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default NewContentAutomaticAlbum;
